import React from 'react';

import styles from './AnimationCube.module.css';

export const AnimationCube = ({ animationDelay }: { animationDelay: string }) => (
  <div
    className={`float-left size-1/3 bg-tuna-shade ${styles.animationCube}`}
    style={{ animationDelay }}
  />
);
